import { merchantKnowledgeSuggestionListItemSchema } from "@redotech/shopper-agent-knowledge-common/suggested-merchant-knowledge-view";
import * as z from "zod";

/**
 * The review queue, most-justified first. Pending proposals only: they have no
 * registry entry, so the agent cannot reach them until one is accepted.
 */
export const listSuggestedKnowledge = {
  name: "listSuggestedKnowledge" as const,
  input: z.object({
    /** Present switches to index-backed search; absent browses the table. */
    query: z.string().optional(),
    limit: z.number().int().positive().optional(),
    offset: z.number().int().nonnegative().optional(),
  }),
  output: z.object({
    suggestions: z.array(merchantKnowledgeSuggestionListItemSchema),
    totalCount: z.number(),
  }),
};
